import {
	GET_EMAIL_API_SETTINGS_FAIL,
	GET_EMAIL_API_SETTINGS_REQ,
	GET_EMAIL_API_SETTINGS_SUCCESS,
	SAVE_HUNTER_SETTINGS_FAIL,
	SAVE_HUNTER_SETTINGS_REQ,
	SAVE_HUNTER_SETTINGS_SUCCESS,
	SAVE_TOMBA_SETTINGS_FAIL,
	SAVE_TOMBA_SETTINGS_REQ,
	SAVE_TOMBA_SETTINGS_SUCCESS,
	SAVE_ABSTRACT_SETTINGS_REQ,
	SAVE_ABSTRACT_SETTINGS_SUCCESS,
	SAVE_ABSTRACT_SETTINGS_FAIL
} from '../constants/settings';

import { toast } from 'react-toastify';

import api from '../../services/api';

export const getApiSettings = () => async (dispatch, getState) => {
	try {
		dispatch({ type: GET_EMAIL_API_SETTINGS_REQ });
		const {
			userLogin: { userInfo },
		} = getState();

		const config = {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${userInfo.gmBackendToken}`,
			},
		};

		const { data } = await api.get(`/api/email-api-settings`, config);

		dispatch({
			type: GET_EMAIL_API_SETTINGS_SUCCESS,
			payload: data?.body,
		});
	} catch (error) {
		dispatch({
			type: GET_EMAIL_API_SETTINGS_FAIL,
			payload:
				error.response && error.response.data.error
					? error.response.data.error
					: error.message,
		});

		const message =
			error.response && error.response.data.error
				? error.response.data.error
				: error.message;

		if (message === 'NotAuthorized') {
			toast.error('Please login from extension and the reload this page');
			localStorage.removeItem('_gm_usr');
			window.location.reload();
		}else if(error.response.status === 401){
			toast.error("Autorization failed, please re-login to the extension")
		}
		 else {
			toast.error(message);
		}
	}
};

export const updateTombaEmailApiSettings =
	(tomba) => async (dispatch, getState) => {
		try {
			dispatch({
				type: SAVE_TOMBA_SETTINGS_REQ,
			});

			const {
				userLogin: { userInfo },
			} = getState();

			const config = {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${userInfo.gmBackendToken}`,
				},
			};

			const { data } = await api.post(`/api/email-api-settings`, tomba, config);

			toast.success(data?.message || 'API Settings Updated Successfully');

			dispatch({
				type: SAVE_TOMBA_SETTINGS_SUCCESS,
				payload: data?.body,
			});
		} catch (error) {
			const message =
				error.response && error.response.data.error
					? error.response.data.error
					: error.message;

			dispatch({
				type: SAVE_TOMBA_SETTINGS_FAIL,
				payload: message,
			});
			if (message === 'NotAuthorized') {
				toast.error('Please login from extension and the reload this page');
				localStorage.removeItem('_gm_usr');
				window.location.reload();
			} else if(error.response.status === 401){
				toast.error("Autorization failed, please re-login to the extension")
			} else {
				toast.error(message);
			}
		}
	};

export const updateHunterEmailApiSettings =
	(hunter) => async (dispatch, getState) => {
		try {
			dispatch({
				type: SAVE_HUNTER_SETTINGS_REQ,
			});

			const {
				userLogin: { userInfo },
			} = getState();

			const config = {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${userInfo.gmBackendToken}`,
				},
			};

			const { data } = await api.post(
				`/api/email-api-settings`,
				hunter,
				config
			);

			dispatch({
				type: SAVE_HUNTER_SETTINGS_SUCCESS,
				payload: data?.body,
			});

			toast.success(data?.message || 'API Settings Updated Successfully');
		} catch (error) {
			const message =
				error.response && error.response.data.error
					? error.response.data.error
					: error.message;
			if (message === 'NotAuthorized') {
				toast.error('Please login from extension and the reload this page');
				localStorage.removeItem('_gm_usr');
				window.location.reload();
			} else if(error.response.status === 401){
				toast.error("Autorization failed, please re-login to the extension")
			} else {
				toast.error(message);
			}
			dispatch({
				type: SAVE_HUNTER_SETTINGS_FAIL,
				payload: message,
			});
		}
	};


	export const updateAbstractEmailApiSettings =
	(abstract) => async (dispatch, getState) => {
		try {
			dispatch({
				type: SAVE_ABSTRACT_SETTINGS_REQ,
			});

			const {
				userLogin: { userInfo },
			} = getState();

			const config = {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${userInfo.gmBackendToken}`,
				},
			};

			const { data } = await api.post(
				`/api/email-api-settings`,
				abstract,
				config
			);

			dispatch({
				type: SAVE_ABSTRACT_SETTINGS_SUCCESS,
				payload: data?.body,
			});

			toast.success(data?.message || 'API Settings Has Been Updated Successfully');
		} catch (error) {
			const message =
				error.response && error.response.data.error
					? error.response.data.error
					: error.message;
			if (message === 'NotAuthorized') {
				toast.error('Please login from extension and the reload this page');
				localStorage.removeItem('_gm_usr');
				window.location.reload();
			} else if(error.response.status === 401){
				toast.error("Autorization failed, please re-login to the extension")
			} else {
				toast.error(message);
			}
			dispatch({
				type: SAVE_ABSTRACT_SETTINGS_FAIL,
				payload: message,
			});
		}
	};

